import { Link } from 'react-router-dom';
import s from '../../styles/components/shows/JoinFans.module.css';

export default function JoinFans({ data }) {
  return (
    <div className={s.container}>
      <h2 className={s.headline}>{data.headline}</h2>
      {data.subhead && <p className={s.subhead}>{data.subhead}</p>}
      <Link to={data.buttonUrl} className={s.btn}>
        {data.buttonLabel}
      </Link>
      {data.blurb && <p className={s.blurb}>{data.blurb}</p>}
    </div>
  );
}